import styled from 'styled-components';
import SearchInput from '../../../../components/Form/SearchInput';
import { level1Content } from '../../../../styles/shareableStyles';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  ${level1Content};
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
  padding: 16px 24px;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
`;

export const Footer = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledLabel = styled.div`
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

export const Column = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
`;

export const StyledSearchInput = styled(SearchInput)`
  flex: 0 0 auto;
  width: 240px;
`;
